import React from "react";
import { Link } from "react-router-dom";


function Footer() {
  return (
    <div className="footer-container-bg">
      <div className="footer-container-main">
        <div className="footer-container-row-main">


<div className="footer-content-cols"> 
  <div className="footer-content-header">CATEGORIES</div>

  <div className="footer-content-header-chield"> <Link to="/">Home </Link> </div>
  <div className="footer-content-header-chield"> <Link to="/collection/giftbox"> Gift Boxes - Combos</Link> </div>
  <div className="footer-content-header-chield"> <Link to="/collection/jaiputiset"> Jaipuri Sets </Link> </div>
  <div className="footer-content-header-chield"> <Link to="/"> All Earrings </Link> </div>
  <div className="footer-content-header-chield"> <Link to="/collection/rings">Rings </Link> </div>
  <div className="footer-content-header-chield"> <Link to="/collection/bracelets">Bracelets </Link> </div>
  <div className="footer-content-header-chield"> <Link to="/collection/anklets">Anklets </Link> </div>
  <div className="footer-content-header-chield"> <Link to="/collection/nose-rings">Nose Rings </Link> </div>

    </div>
<div className="footer-content-cols"> 
    <div className="footer-content-header">Information</div>

      <div className="footer-content-header-chield"> <a href="#">Privacy Policy </a> </div>
  <div className="footer-content-header-chield"> <a href="#"> Terms and Conditions</a> </div>
  <div className="footer-content-header-chield"> <a href="#">Return & Shipping Policy </a> </div>



 </div>
<div className="footer-content-cols"> 
    <div className="footer-content-header">CONTACT US</div>
        <div className="footer-content-header-chield"> <a href="#">Whatsapp Us </a> </div>
  <div className="footer-content-header-chield"> <a href="#"> 📍 kuina, Near Shantaram Electrical Industry, Chinchwad, Pune 411018</a> </div>
  <div className="footer-content-header-chield"> <a href="#">📧 support@kuina.in */ </a> </div>



</div>
<div className="footer-content-cols"> 
    <div className="footer-content-header">FOLLOW US</div>


         <div className="footer-content-header-chield"> <a href="#">Instagram - @kuina.in </a> </div>
  <div className="footer-content-header-chield"> <a href="#">Youtube - @kuina.in</a> </div>
  <div className="footer-content-header-chield"> <a href="#">Facebook - @kuina </a> </div>

  </div>



        </div>
      </div>
    </div>
  );
}

export default Footer;
